import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 24,
    lineHeight: '32px',
    fontWeight: 400,
    marginTop: theme.spacing(6),
    gap: theme.spacing(2)
  },
  card: {
    display: 'flex',
    width: '360px',
    flexDirection: 'column',
    background: theme.colorPalette.green_90,
    padding: theme.spacing(6),
    borderRadius: theme.spacing(1.5),
    gap: theme.spacing(2),
    marginBottom: theme.spacing(4)
  },
  row: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center'
  },
  titleColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1)
  },
  code: {
    fontSize: 10,
    lineHeight: '12px',
    fontWeight: 600,
    color: theme.colorPalette.orange_75
  },
  title: {
    color: theme.colorPalette.white,
    fontSize: 20,
    lineHeight: '24px',
    fontWeight: 600
  },
  branchPlusEligible: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.colorPalette.green_80,
    color: theme.colorPalette.beige_25,
    borderRadius: theme.spacing(4),
    padding: theme.spacing(0, 2),
    height: 26,
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 600
  },
  subtitle: {
    textAlign: 'left',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    color: theme.colorPalette.beige_25
  },
  iconRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    fontSize: 10,
    fontWeight: 600,
    lineHeight: '12px',
    color: theme.colorPalette.white
  },
  subBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    border: `2px solid ${theme.colorPalette.green_80}`,
    borderRadius: 4,
    padding: theme.spacing(2),
    gap: theme.spacing(2)
  },
  boxContent: {
    textAlign: 'left',
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 400,
    color: theme.colorPalette.white
  },
  icon: {
    marginRight: theme.spacing(1)
  },
  overrideButton: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: 24,
    width: '100%'
  },
  overrideCheckbox: {
    color: theme.colorPalette.white
  },
  inaccurateButton: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: 24
  },
  simulatedBadge: {
    '&&': {
      maxWidth: 'none',
      backgroundColor: theme.colorPalette.white_30,
      color: theme.colorPalette.beige_90
    }
  }
}));

export default useStyles;
